/* src/app/components/upload/upload.component.scss */
.notice {
  font-style: italic;
  margin-top: 20px;
}
::ng-deep .mat-mdc-select-panel {
  width: 500px !important;
}
.actions {
  position: absolute;
  top: 12px;
  right: 12px;
}
/*# sourceMappingURL=upload.component-IMXP24VG.css.map */
